import React from "react";
import { Link, NavLink } from "react-router-dom";
import { Flame, Trophy, Sparkles } from "lucide-react";
import { useProgress } from "../context/ProgressContext";
import { computeLevel } from "../data/modules";

export function Header() {
  const { progress } = useProgress();
  const { level } = computeLevel(progress.xp || 0);

  return (
    <header className="border-b border-border bg-background/80 backdrop-blur sticky top-0 z-30">
      <div className="max-w-7xl mx-auto px-6 md:px-10 h-16 flex items-center justify-between">
        <Link to="/" data-testid="brand-logo" className="flex items-center gap-3 group">
          <div className="w-8 h-8 rounded-sm border-2 border-primary flex items-center justify-center bg-primary/5">
            <Sparkles className="w-4 h-4 text-primary" strokeWidth={2.2} />
          </div>
          <div className="leading-none">
            <div className="font-serif-display text-xl">Prompt Craft</div>
            <div className="font-mono-code text-[10px] uppercase tracking-widest text-muted-foreground">
              micro · learning
            </div>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-8 text-sm font-medium">
          <NavLink
            data-testid="nav-modules"
            to="/"
            end
            className={({ isActive }) =>
              "hover:text-primary transition-colors " + (isActive ? "text-primary" : "text-foreground/80")
            }
          >
            Modules
          </NavLink>
          <NavLink
            data-testid="nav-badges"
            to="/badges"
            className={({ isActive }) =>
              "hover:text-primary transition-colors " + (isActive ? "text-primary" : "text-foreground/80")
            }
          >
            Badges
          </NavLink>
          <NavLink
            data-testid="nav-leaderboard"
            to="/leaderboard"
            className={({ isActive }) =>
              "hover:text-primary transition-colors " + (isActive ? "text-primary" : "text-foreground/80")
            }
          >
            Leaderboard
          </NavLink>
        </nav>

        <div className="flex items-center gap-4 md:gap-6 font-mono-code text-xs">
          <div className="flex items-center gap-1.5" data-testid="header-streak">
            <Flame className="w-4 h-4 text-primary" />
            <span className="font-bold">{progress.streak || 0}</span>
            <span className="hidden sm:inline text-muted-foreground uppercase">streak</span>
          </div>
          <div className="flex items-center gap-1.5" data-testid="header-xp">
            <Trophy className="w-4 h-4 text-primary" />
            <span className="font-bold">{progress.xp || 0}</span>
            <span className="hidden sm:inline text-muted-foreground uppercase">xp</span>
          </div>
          <div className="hidden sm:flex items-center px-2 py-1 border border-border" data-testid="header-level">
            <span className="text-muted-foreground uppercase mr-1">Lv</span>
            <span className="font-bold">{level}</span>
          </div>
        </div>
      </div>
    </header>
  );
}
